/**
 * Utilitaires pour le formatage des dates
 */

/**
 * Formate une date en format français (DD/MM/YYYY)
 * @param {Date|Object|string} dateValue - La valeur de date à formater
 * @returns {string} - La date formatée
 */
export const formatDate = (dateValue) => {
  // Si c'est un timestamp Firestore
  if (dateValue && typeof dateValue.toDate === 'function') {
    return dateValue.toDate().toLocaleDateString('fr-FR');
  }
  
  // Si c'est déjà une date JavaScript
  if (dateValue instanceof Date && !isNaN(dateValue)) {
    return dateValue.toLocaleDateString('fr-FR');
  }
  
  // Si c'est une chaîne de caractères, essayons plusieurs approches
  if (typeof dateValue === 'string') {
    // Si c'est une date en format ISO
    if (dateValue.match(/^\d{4}-\d{2}-\d{2}/)) {
      return new Date(dateValue).toLocaleDateString('fr-FR');
    }
    
    // Si c'est un format français
    const frenchDateRegex = /(\d+)\s+(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)\s+(\d{4})/i;
    const match = dateValue.match(frenchDateRegex);
    
    if (match) {
      const monthNames = {
        'janvier': 0, 'février': 1, 'mars': 2, 'avril': 3, 'mai': 4, 'juin': 5,
        'juillet': 6, 'août': 7, 'septembre': 8, 'octobre': 9, 'novembre': 10, 'décembre': 11
      };
      
      const day = parseInt(match[1]);
      const month = monthNames[match[2].toLowerCase()];
      const year = parseInt(match[3]);
      
      if (!isNaN(day) && month !== undefined && !isNaN(year)) {
        return new Date(year, month, day).toLocaleDateString('fr-FR');
      }
    }
  }
  // Valeur par défaut si rien ne fonctionne
  return "Date non disponible";
};